import { render, staticRenderFns } from "./PurchaseAging.vue?vue&type=template&id=d4bdf904&"
import script from "./PurchaseAging.vue?vue&type=script&lang=js&"
export * from "./PurchaseAging.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports